import React from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import { EndAdornment, StartAdornment } from './Adornments';
import typography from '../../../theme/typography';
import { handleSearchSelect } from '../../search/helpers';
import { goToSearchPage } from './useCuisineAndRestaurantSearch';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    width: theme.spacing(45),
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: theme.spacing(0.5),
    },
    '& .MuiInputAdornment-positionEnd': {
      marginLeft: theme.spacing(0.5),
    },
    '& .MuiOutlinedInput-input': {
      padding: theme.spacing(1.75, 0),
    },
    '& .MuiOutlinedInput-root, & .MuiOutlinedInput-notchedOutline': {
      borderRadius: theme.spacing(0.75),
      borderColor: theme.palette.secondary[65],
    },
    '& .MuiInputBase-input': {
      ...typography.medium1Normal,
      '&::placeholder': {
        ...typography.small2Normal,
        opacity: 1,
      },
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.spoon.blue[40],
    },
  },
}));

/**
 * SearchBar component for use with @material-ui/lab useAutocomplete hook
 *
 * @param {object} props
 * @param {object} [props.classes] Extends default styles
 * @param {function} [props.getInputProps] `getInputProps` function from useAutocomplete hook
 * @param {function} [props.getClearProps] `getClearProps` function from useAutocomplete hook
 * @param {string} [props.placeholder] Placeholder text
 * @returns {JSX.Element}
 */
export const SearchBar = ({
  getInputProps,
  getClearProps,
  placeholder,
  autoFocus,
  classes: classesOverride,
}) => {
  const classes = useStyles({ classes: classesOverride });
  const inputProps = getInputProps();
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <TextField
      autoFocus={autoFocus}
      className={classes.root}
      variant="outlined"
      placeholder={placeholder}
      inputProps={{
        'aria-label': placeholder,
      }}
      InputProps={{
        ...inputProps,
        onKeyDown: (event) => {
          if (event.key === 'Enter' && !inputProps.value) {
            handleSearchSelect('', dispatch, true);
            goToSearchPage(history);
            document.activeElement.blur();
          }
        },
        'aria-autocomplete': undefined,
        startAdornment: <StartAdornment />,
        endAdornment: getInputProps().value?.length > 0 && (
          <EndAdornment
            onClick={() => {
              getClearProps().onClick();
              inputProps.ref.current?.querySelector('input').focus();
            }}
          />
        ),
      }}
    />
  );
};

export default SearchBar;
